module.exports = ".heightstream{\n    height: 500px;\n}\n\n.textcolor{\n    color: white;\n}"